import {
    ERROR_MESSAGE_GENERIC,
    ERROR_MESSAGE_NO_NETWORK,
    FIELDS,
    httpCodeBadRequest,
    httpCodeBrokenNetwork,
    httpCodeConflict,
    httpCodeInvalidInputs,
    httpCodeNotAcceptable,
    httpCodeNotFound,
} from '../utils/constants.utils';
import axios, { AxiosError } from 'axios';
import { ShowMessage } from '../hooks/snackbar.hook';

/**
 * Récupération du contenu d'une page grâce à son code
 * Attribut : key => string
 **/
export const showAxiosMessageError = (error: Error | AxiosError, showMessage: ShowMessage) => {
    // Init message générique
    let message = ERROR_MESSAGE_GENERIC;

    // Location
    const url = window.location.href;

    // includes pour éviter code smells et avoir une condition plus courte en dessous
    const URL_KEYS = [
        'rattacher-un-contrat',
        'rattachement-contrat',
        'paiement-facture',
        'identifiant-perdu',
        'releve-compteur',
    ];

    let includes = URL_KEYS.some(key => url?.includes(key));

    if (axios.isAxiosError(error)) {
        //On met en cancel un appel quand le token est expiré
        if ('ERR_CANCELED' === error?.code) {
            showMessage.infoAlert('Votre session a expiré. Merci de vous reconnecter.');
        } else if (error?.response?.status === httpCodeNotFound && includes) {
            //Affichage de l'erreur sur des pages spécifiques
            showMessage.errorAlert(error.response.data);
        } else if (error?.response?.status === httpCodeNotFound) {
            console.warn('Erreur 404 : ', error.response.data);
        } else {
            switch (error?.response?.status) {
                // httpCodeInvalidInputs : retours champs formulaire
                case httpCodeInvalidInputs:
                    if (error.response.data.violations) {
                        message = constructValidationErrorMessage(error.response.data.violations);
                    } else if (error.response.data.length) {
                        message = error.response.data[0];
                    }
                    break;
                // httpCodeInvalidInputs : retours champs formulaire avec règles (exemple : mdp)
                case httpCodeNotAcceptable:
                    message = constuctErrorMessage(error.response.data);
                    break;
                // Autres erreurs plus simples
                case httpCodeBadRequest:
                    message = error.response.data.message;
                    break;
                case httpCodeConflict:
                    message = error.response.data;
                    break;
                default:
                    message = ERROR_MESSAGE_GENERIC;
                    break;
            }
            // si on a un code httpCodeBrokenNetwork il prime sur tout le reste
            if (error?.code === httpCodeBrokenNetwork) {
                message = ERROR_MESSAGE_NO_NETWORK;
            }
            //Affichage de l'erreur
            showMessage.errorAlert(message);
        }
    } else {
        //Affichage de l'erreur
        showMessage.errorAlert(message);
    }
};

/**
 * Méthode qui permet de construire le texte à afficher en cas d'erreur de format du mot de passe
 * @param response retour d'axios sur une erreur de type 406
 */
export function constuctErrorMessage(response: string[] | any) {
    if (response?.message) {
        return response?.message;
    }

    if (typeof response === 'string') {
        return response;
    }

    //On parcourt les elements pour afficher les règles.
    if (Array.isArray(response)) {
        let message = 'Le mot de passe ne respecte pas ces règles : \n';
        response.forEach(element => {
            message += '- ' + element + '\n';
        });
        return message;
    }
    return ERROR_MESSAGE_GENERIC;
}

/**
 * Méthode qui affiche les messages d'erreurs du back
 * @param violations liste des messages d'erreurs
 */
export function constructValidationErrorMessage(violations: any[]) {
    //On parcourt les elements pour afficher les erreurs.
    let errorMessage = 'Certains champs ne sont pas valides : \n';
    violations.forEach(element => {
        errorMessage += '- ' + FIELDS.get(element.propertyPath) + ' : ' + element.message + '\n';
    });
    return errorMessage;
}
